import { useRecoilValue } from 'recoil';
import { scenarioState } from '../../stores/scenarioState';
import { scenarioCompletionState } from '../../stores/scenarioCompletionState';

const Header = () => {
  const scenario = useRecoilValue(scenarioState);
  const { totalCount, completedCount, completionRatio } = useRecoilValue(scenarioCompletionState);

  return (
    <header className="header">
      <span className="title">
        {scenario.header.title}
      </span>
      {totalCount > 0 && (
        <>
          <span className="complete-ratio-text fadeIn">{Math.round(completionRatio * 100) + '%'}</span>
          <span className="complete-ratio fadeIn">
            <span className="complete-ratio-inner">
              <span className="complete-ratio-bar" style={{width: completionRatio * 100 + '%'}}/>
            </span>
          </span>
          <span className="complete-ratio-total fadeIn">{totalCount + '問中'}</span>
          <span className="complete-ratio-answered fadeIn">{completedCount + '問'}</span>
        </>
      )}
    </header>
  );
};

export default Header;
